import "../scss/styles.scss";
import * as bootstrap from "bootstrap";
// import "../js/globe.js";

import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
// ScrollSmoother requires ScrollTrigger
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, ScrollToPlugin);

import Swiper from "swiper";
import { Autoplay, Scrollbar, Navigation } from "swiper/modules";
// import 'swiper/css';
// import 'swiper/css/autoplay';

// import Lenis from 'lenis'

function isSmall() {
  return window.innerWidth < 640 && window.innerHeight > window.innerWidth;
}
function isMobile() {
  return mobileSniff(); // /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(window.navigator.userAgent);
}
function iPhoneSniff() {
  return /iP(ad|hone|od).*OS/.test(window.navigator.userAgent);
}
function androidSniff() {
  return /Android/.test(window.navigator.userAgent);
}
function mobileSniff() {
  return iPhoneSniff() || androidSniff();
}

let smoother, smootherProgress, prevDirection = 0;;
window.addEventListener("load", (e) => {
  if (isMobile()) {
    ScrollTrigger.create({
      trigger: "#smooth-content",
      start: "top+=80 top",
      end: 30000,
      toggleClass: {
        targets: [".navbar", "#backToTop"],
        className: "scrolled",
      },
      onUpdate: (self) => {
        // Check if direction has changed
        if (self.direction !== prevDirection) {
          // console.log("Direction changed!");
          if (self.direction === -1) {
            // console.log("Scrolling UP");
            document.getElementById("backToTop").classList.add("scroll-up");
          } else {
            // console.log("Scrolling DOWN");
            document.getElementById("backToTop").classList.remove("scroll-up");
          }
          prevDirection = self.direction; // Update the previous direction
        }
      }
    });
    initTabs();
    threeIsMobile();
    // pinToolCards();
    initFutureGovTabs();
    // collaborationTexts();
    initHero();
    initHeadings();
    ScrollTrigger.refresh();
  } else {
    ScrollTrigger.create({
      trigger: "#smooth-content",
      start: "top+=80 top",
      end: 30000,
      toggleClass: {
        targets: [".navbar", "#backToTop"],
        className: "scrolled",
      },
      onUpdate: (self) => {
        // Check if direction has changed
        if (self.direction !== prevDirection) {
          // console.log("Direction changed!");
          if (self.direction === -1) {
            // console.log("Scrolling UP");
            document.getElementById("backToTop").classList.add("scroll-up");
          } else {
            // console.log("Scrolling DOWN");
            document.getElementById("backToTop").classList.remove("scroll-up");
          }
          prevDirection = self.direction; // Update the previous direction
        }
      }
    });
    blursAnimation();
    initTabs();
    threeIs();
    initFutureGovTabs();
    servicesMouseFollower();
    pinToolCards();
    collaborationTexts();
    initHero();
    initHeadings();
    initAccordionClicks();
    // GSAP ScrollSmoother
    smoother = ScrollSmoother.create({
      smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
      effects: true, // looks for data-speed and data-lag attributes on elements
      smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
      speed: 0.5,
      // normalizeScroll: true, // prevents weird iOS/Android scroll jank
    });
    // Lenis smooth scrolling
    // Initialize a new Lenis instance for smooth scrolling
    // smoother = new Lenis({
    //   anchors: true
    // });

    // // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
    // smoother.on('scroll', ScrollTrigger.update);

    // // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
    // // This ensures Lenis's smooth scroll animation updates on each GSAP tick
    // gsap.ticker.add((time) => {
    //   smoother.raf(time * 1000); // Convert time from seconds to milliseconds
    // });

    // // Disable lag smoothing in GSAP to prevent any delay in scroll animations
    // gsap.ticker.lagSmoothing(0);

    ScrollTrigger.refresh();
  }
  var btn = document.getElementById("backToTop");

  btn.addEventListener("click", function (e) {
    e.preventDefault();
    if (isMobile()) {
      window.scrollTo(0, true);
    } else {
      if (smoother) {
        smoother.scrollTo(0, true);
      } else {
        gsap.to(window, { scrollTo: 0 });
      }
    }
  });

  var logo = document.getElementById("logoBackToTop");

  logo.addEventListener("click", function (e) {
    e.preventDefault();
    if (isMobile()) {
      window.scrollTo(0, true);
    } else {
      if (smoother) {
        smoother.scrollTo(0, true);
      } else {
        gsap.to(window, { scrollTo: 0 });
      }
    }
  });

  gsap.to("body", {
    duration: 0.5,
    autoAlpha: 1,
    delay: 0.5,
    onComplete: startHeroAnimation,
  });
});

const initHeadings = () => {
  document.querySelectorAll(".h1").forEach((heading) => {
    gsap.from(heading, {
      duration: 0.6,
      y: "-=40",
      autoAlpha: 0,
      scrollTrigger: {
        trigger: heading,
        start: "top center+=25%",
        toggleActions: "play none resume reverse",
      }
    });
  });
}

const bsOffcanvas = new bootstrap.Offcanvas("#offcanvasRight");
// If a link's href is within the current page, scroll to it instead
document.querySelectorAll("header a[href]").forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const offset = e.target.dataset.gsOffset || 0;
    const link = e.target.href.split("#")[1];

    if (isMobile()) {
      gsap.to(window, {scrollTo :("#" + link)});
    } else {
      if (smoother) {
        smoother.scrollTo("#" + link, true, `top ${offset}px`);
      } else {
        gsap.to(window, { scrollTo: "#" + link });
      }
    }

    bsOffcanvas.hide();
    return false;
  });
});

const skipBtn = document.querySelector(".skip-btn");
skipBtn.addEventListener("click", (e) => {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  // const offset = e.target.dataset.gsOffset || 0;
  const link = e.target.href.split("#")[1];
  if (smoother) {
    smoother.scrollTo("#" + link, true, `top -100px`);
  } else {
    gsap.to(window, { scrollTo: "#" + link });
  }
  return false;
});

const heroTl = gsap.timeline({ paused: true });
// const mouseTl = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".hero",
//     start: "top-=130 top",
//     end: "150 top+=150",
//     markers: true
//   }
// });
const initHero = () => {
  const heroText1 = SplitText.create(".hero .h1 .gradient", {
    type: "chars,words",
    autoSplit: true,
    onSplit: (self) => {
      heroTl.from(self.chars, {
        duration: 0.3,
        stagger: 0.02,
        scale: 1.2,
        autoAlpha: 0,
        // ease: "back.out",
      });
    }
  });
  const heroText2 = SplitText.create(".hero .h1 .color", {
    type: "words",
    autoSplit: true,
    onSplit: (self) => {
      heroTl.from(self.words, {
        duration: 0.5,
        stagger: 0.1,
        scale: 1.5,
        autoAlpha: 0,
      });
    }
  });
  // const elipseTl = gsap.timeline({
  //   scrollTrigger: {
  //     trigger: "#BlurVisible",
  //     start: "top top+=115",
  //     scrub: 1.5,
  //   },
  // });
  // elipseTl.to(".hero .ellipse", {
  //   yPercent: -15,
  //   // xPercent: "-=5",
  // });
};
const startHeroAnimation = () => {
  ScrollTrigger.refresh();
  heroTl.play();

  // mouseTl.set(".mouse", {left: "calc(50% - 20px)", top: "70dvh"});
  // mouseTl.to({p: 0}, {duration: 3});
  // mouseTl.to(".mouse", {
  //   duration: 0.8,
  //   autoAlpha: 1,
  // })
  // mouseTl.to(".mouse", {
  //   duration: 0.6,
  //   autoAlpha: 0,
  // })
};

let blurMoveHandler, futureBlurMoveHandler; // ще пазим тук handler-а
// let xTo, yTo;

function blursAnimation() {
  gsap.set(".main-blurs", { xPercent: -50, yPercent: -50 });

  let xTo = gsap.quickTo(".main-blurs", "x", { duration: 0.6, ease: "power3" }),
    yTo = gsap.quickTo(".main-blurs", "y", { duration: 0.6, ease: "power3" });

  // window.addEventListener("mousemove", e => {
  //   xTo(e.clientX);
  //   yTo(e.clientY);
  // });
  blurMoveHandler = (e) => {
    xTo(e.clientX);
    yTo(e.clientY);
  };
  window.addEventListener("mousemove", blurMoveHandler);
  ScrollTrigger.create({
    trigger: "#BlurVisible",
    start: "top top",
    end: "bottom 75%",
    onEnter: ({ progress, direction, isActive }) => {
      startBlursAnimation();
    },
    onLeave: ({ progress, direction, isActive }) => {
      stopBlursAnimation();
    },
    onEnterBack: ({ progress, direction, isActive }) => {
      startBlursAnimation();
    },
    // markers: true,
  });
}

function stopBlursAnimation() {
  if (blurMoveHandler) {
    gsap.to(".main-blurs", {
      opacity: 0,
      duration: 0.5,
      onComplete: () => {
        window.removeEventListener("mousemove", blurMoveHandler);
      },
    });
  }
}
function startBlursAnimation() {
  if (blurMoveHandler) {
    gsap.to(".main-blurs", {
      opacity: 1,
      duration: 0.5,
      onComplete: () => {
        window.addEventListener("mousemove", blurMoveHandler);
      },
    });
  }
}

function stopFutureBlursAnimation() {
  if (futureBlurMoveHandler) {
    gsap.to(".future-blurs", {
      opacity: 0,
      duration: 0.5,
      onComplete: () => {
        window.removeEventListener("mousemove", futureBlurMoveHandler);
      },
    });
  }
}
function startFutureBlursAnimation() {
  if (futureBlurMoveHandler) {
    gsap.to(".future-blurs", {
      opacity: 1,
      duration: 0.5,
      onComplete: () => {
        window.addEventListener("mousemove", futureBlurMoveHandler);
      },
    });
  }
}

function servicesMouseFollower() {
  const mouseBoxes = gsap.utils.toArray(".Services .card-wrapper");

  const follower = document.querySelector(".mouseFollower");
  gsap.set(follower, {
    xPercent: -50,
    yPercent: -50,
    scale: 0,
    opacity: 1,
  });
  const xTo = gsap.quickTo(follower, "x", { duration: 0.3, ease: "power2" });
  const yTo = gsap.quickTo(follower, "y", { duration: 0.3, ease: "power2" });
  const scaleTween = gsap.to(follower, {
    scale: 1,
    ease: "power1.inOut",
    paused: true,
  });

  mouseBoxes.forEach((box) => {
    box.addEventListener("mouseenter", () => {
      /*stopBlursAnimation();*/ scaleTween.play();
    });
    box.addEventListener("mouseleave", () => {
      /*startBlursAnimation();*/ scaleTween.reverse();
    });
    box.addEventListener("mousemove", (e) => {
      // const rect = box.getBoundingClientRect();
      const x = e.clientX; // - rect.left;
      const y = e.clientY; // - rect.top;
      xTo(x);
      yTo(y);
    });
  });
}

const quoteAnimation = document.querySelectorAll(".WellcomeQuote .animation");
const textQuote = new SplitText(".WellcomeQuote .text", { type: "words" });
const quoteTl = gsap.timeline({
  scrollTrigger: {
    trigger: quoteAnimation,
    start: "top bottom-=20%",
    end: "bottom bottom-=45%",
    // toggleActions: "play none reverse reset",
    toggleActions: "play none resume reverse",
    // markers: true,
    fastScrollEnd: true,
  },
});
quoteTl.from(quoteAnimation, {
  opacity: 0,
  y: 100,
  duration: 0.5,
  stagger: 0.1,
});
quoteTl.from(
  textQuote.words,
  {
    duration: 0.1,
    stagger: 0.007,
    autoAlpha: 0,
  },
  0
);

let currentTab = 0;
const tabs = document.querySelectorAll(".OurFocus .tab-content");
const images = document.querySelectorAll(".OurFocus .tabs-images .tab-image");
const tabsSwitchDuration = 0.4; // overal tabs animation duration
const tabsAutoplayDuration = 10; // 10s for switching tabs
function initTabs() {
  tabs.forEach((tab, idx) => {
    const p = tab.querySelector(".tab-pane");
    tab.setAttribute("data-height", p.offsetHeight + 1);
    tab.setAttribute("data-id", idx);
    p.style.height = 0;
    tab.addEventListener("click", function (e) {
      if (this.classList.contains("active")) return;

      currentTab = parseInt(this.dataset.id);
      changeTab(this);
    });
    // tab.addEventListener("mouseenter", function (e) {
    //   autoplayTl.pause();
    // });
    // tab.addEventListener("mouseleave", function (e) {
    //   autoplayTl.play();
    // });
  });

  // set first tab as active
  const curr = tabs[currentTab];
  curr.classList.add("active");
  gsap.set(curr.querySelector(".tab-pane"), { height: curr.dataset.height });
  // image
  const curri = images[currentTab];
  curri.classList.add("active");
  gsap.set(curri, { autoAlpha: 1 });

  //
  autoplayTabs();

  ScrollTrigger.create({
    trigger: ".OurFocus",
    start: "top bottom",
    end: "bottom center-=15%",
    fastScrollEnd: true,
    onEnter: ({ progress, direction, isActive }) => {
      autoplayTl.play();
    },
    onLeave: ({ progress, direction, isActive }) => {
      autoplayTl.pause();
    },
    onEnterBack: ({ progress, direction, isActive }) => {
      autoplayTl.play();
    },
    onLeaveBack: ({ progress, direction, isActive }) => {
      autoplayTl.pause();
    },
    // markers: true,
  });
}

function changeTab(tab) {
  // unset active tab
  const active = document.querySelector(".OurFocus .tab-content.active");
  const activep = active.querySelector(".tab-pane");
  active.classList.remove("active");
  gsap.to(active.querySelector(".progress"), { duration: 0.4, width: "0%" });

  // set clicked tab as active
  const p = tab.querySelector(".tab-pane");
  tab.classList.add("active");

  //unset active image
  const activei = document.querySelector(
    ".OurFocus .tabs-images .tab-image.active"
  );
  activei.classList.remove("active");

  // set active image
  const img = images[currentTab];
  img.classList.add("active");

  // gsap
  const tl = gsap.timeline();
  tl.to(activep, {
    duration: tabsSwitchDuration,
    height: 0,
  })
    .to(
      p,
      {
        duration: tabsSwitchDuration,
        height: tab.dataset.height,
      },
      0
    )
    .to(
      activei,
      {
        duration: tabsSwitchDuration,
        autoAlpha: 0,
      },
      0
    )
    .fromTo(
      img,
      {
        top: 0,
      },
      {
        duration: tabsSwitchDuration,
        autoAlpha: 1,
        // top: "50%",
      }
    );
  autoplayTl.restart();
}

const autoplayTl = gsap.timeline({ repeat: -1, paused: true });
function autoplayTabs() {
  autoplayTl.to(
    { time: 0 },
    {
      duration: tabsAutoplayDuration,
      ease: "none",
      onComplete: () => {
        currentTab = ++currentTab % tabs.length;
        changeTab(tabs[currentTab]);
      },
      onUpdate: function () {
        const tab = tabs[currentTab];
        const currProgress = tab.querySelector(".progress");
        gsap.set(currProgress, { width: this.progress() * 100 + "%" });
      },
    }
  );
}

// create trigger for playing/pausing tabs autoplay
// if (document.querySelector("body").classList.contains("HomePage")) {
//   ScrollTrigger.create({
//     trigger: ".OurFocus",
//     start: "top center",
//     end: "bottom top",
//     // onEnter: () => autoplayTl.play(),
//     // onEnterBack: () => autoplayTl.play(),
//     // onLeave: () => autoplayTl.pause(),
//     // onLeaveBack: () => autoplayTl.pause(),
//   });

//   ScrollTrigger.create({
//     trigger: ".FutureGov",
//     start: "top center",
//     end: "bottom top",
//     // onEnter: () => autoplayFTl.play(),
//     // onEnterBack: () => autoplayFTl.play(),
//     // onLeave: () => autoplayFTl.pause(),
//     // onLeaveBack: () => autoplayFTl.pause(),
//   });
// }

const threeIs = function () {
  const titleWidth1 = document.querySelector(".pinned .titles .first").offsetWidth;
  const titleWidth2 = document.querySelector(".pinned .titles .second").offsetWidth;
  const titleWidth3 = document.querySelector(".pinned .titles .third").offsetWidth;
  const titleHeight1 = document.querySelector(".pinned .titles .first").offsetHeight;
  const titleHeight2 = document.querySelector(".pinned .titles .second").offsetHeight;
  const titleHeight3 = document.querySelector(".pinned .titles .third").offsetHeight;
  const titleHeight = titleHeight1 + titleHeight2 + titleHeight3;
  const totalWidth = titleWidth1 + titleWidth2 + titleWidth3;
  // console.log(titleWidth1, titleWidth2, titleWidth3, totalWidth);

  const el1 = document.querySelector(".first-text");
  const el2 = document.querySelector(".second-text");
  const el3 = document.querySelector(".third-text");
  const maxHeight = Math.max(
    el1.scrollHeight,
    el2.scrollHeight,
    el3.scrollHeight
  );
  const split1 = SplitText.create(".first-text .content-top", {
    type: "words, chars",
  });
  const split2 = SplitText.create(".second-text .content-top", {
    type: "words, chars",
  });
  const split3 = SplitText.create(".third-text .content-top", {
    type: "words, chars",
  });
  const wrapper = document.querySelector(".title-content");
  gsap.set(wrapper, { height: maxHeight + 40 });
  const duration = 5; // trqbva da e >= ot 5

  gsap.set(".pinned .titles", { x: window.innerWidth, width: totalWidth });
  gsap.set(".first-text", { autoAlpha: 0 });
  gsap.set(".second-text", { autoAlpha: 0 });
  gsap.set(".third-text", { autoAlpha: 0 });

  ScrollTrigger.create({
    trigger: ".Approaches.pinned",
    start: "top top+=15%",
    pin: true,
    pinSpacing: true,
    // fastScrollEnd: true,
    end: () =>
      "+=" +
      (el1.scrollHeight +
        el2.scrollHeight +
        el3.scrollHeight +
        5 * titleHeight),
  });
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".Approaches.pinned",
      start: "top bottom+=5%",
      // fastScrollEnd: true,
      end: () =>
        "+=" +
        (el1.scrollHeight +
          el2.scrollHeight +
          el3.scrollHeight +
          5 * titleHeight),
      scrub: 1.5,
      // markers: true,
    },
  });

  // pokazvane na pyrviq tekst
  tl.to(".first-text", {
    autoAlpha: 1,
    duration: 0.9,
  });
  // premestvane na zaglaviqta ot dqsno do 0
  tl.fromTo(
    ".titles",
    {
      duration: duration,
      x: window.innerWidth,
      ease: "inOut",
    },
    {
      duration: duration,
      x: 0,
      ease: "inOut",
    }
  );
  tl.call(() => {
    hideMousePointer();
  });
  tl.call(() => {
    showMousePointer();
  });
  // pokazvane na pyrviq split
  tl.fromTo(
    split1.words,
    {
      autoAlpha: 0.1,
    },
    {
      duration: 1,
      autoAlpha: 1,
      stagger: 0.2,
      ease: "none",
    },
    "<1.5"
  );
  // skrivane na pyrviq tekst
  tl.to(".first-text .content-top", {
    autoAlpha: 0,
    duration: 0.9,
  }); // ">");

  // pokazvane na vtoriq tekst
  tl.to(".second-text", {
    autoAlpha: 1,
    duration: 0.9,
  }); // ">");
  // premestvane na zaglaviqta do vtoroto
  tl.fromTo(
    ".titles",
    {
      duration: duration,
      x: 0,
      ease: "inOut",
    },
    {
      duration: duration,
      x: 0 - titleWidth1,
      ease: "inOut",
    },
    "<"
  );

  // pokazvane na vtoriq split
  tl.fromTo(
    split2.words,
    {
      autoAlpha: 0.1,
    },
    {
      duration: 1,
      autoAlpha: 1,
      stagger: 0.2,
      ease: "none",
    },
    "<1.5"
  );

  // skrivane na vtoriq tekst
  tl.to(".second-text .content-top", {
    autoAlpha: 0,
    duration: 0.9,
  }); // ">");

  // pokazvane na tretiq tekst
  tl.to(".third-text", {
    autoAlpha: 1,
    duration: 0.9,
  }); // ">");
  // premestvane na zaglaviqta do tretoto
  tl.fromTo(
    ".titles",
    {
      duration: duration,
      x: 0 - titleWidth1,
      ease: "inOut",
    },
    {
      duration: duration,
      x: 0 - (titleWidth1 + titleWidth2),
      ease: "inOut",
    },
    "<"
  );
  // pokazvane na tretiq split
  tl.fromTo(
    split3.words,
    {
      autoAlpha: 0.1,
    },
    {
      duration: 1,
      autoAlpha: 1,
      stagger: 0.2,
      ease: "none",
    },
    "<1.5"
  );
  tl.call(() => {
    showMousePointer();
  });
  tl.call(() => {
    hideMousePointer();
  });
};

const threeIsMobile = function () {
  document.querySelectorAll(".mobile-three-i-wrapper .title").forEach((block) => {
  gsap.from(block, {
    duration: 0.3,
    scale: 1.2,
    autoAlpha: 0,
    ease: "back.out",
    scrollTrigger: {
      trigger: block,
      start: "top center+=25%",
      toggleActions: "play none resume reverse",
      // markers: true,
    },
  });
  });
}

function showMousePointer() {
  startMousePointer();
}
function hideMousePointer() {
  stopMousePointer();
}
function stopMousePointer() {
  // if (mousePointerHandler) {
  gsap.to(".skip", {
    autoAlpha: 0,
    duration: 0.5,
    onComplete: () => {
      // window.removeEventListener("mousemove", mousePointerHandler);
    },
  });
  // }
}
function startMousePointer() {
  // if (mousePointerHandler) {
  gsap.to(".skip", {
    autoAlpha: 1,
    x: window.innerWidth / 2 - 40 / 2,
    y: window.innerHeight - 135,
    duration: 0.5,
    onComplete: () => {
      // window.addEventListener("mousemove", mousePointerHandler);
    },
  });
  // }
}

// FutureGov tabs
let currentFTab = 0;
const futureGovTabs = document.querySelectorAll(".FutureGov .tab-content");
function initFutureGovTabs() {
  // tabs autoplay
  futureGovTabs.forEach((tab, idx) => {
    const p = tab.querySelector(".tab-pane");
    tab.setAttribute("data-height", p.offsetHeight + 1);
    tab.setAttribute("data-id", idx);
    p.style.height = 0;
    tab.addEventListener("click", function (e) {
      if (this.classList.contains("active")) return;

      currentFTab = parseInt(this.dataset.id);
      changeFutureTab(this);
    });
    // tab.addEventListener("mouseenter", function (e) {
    //   autoplayFTl.pause();
    // });
    // tab.addEventListener("mouseleave", function (e) {
    //   autoplayFTl.play();
    // });
  });

  // set first tab as active
  const curr = futureGovTabs[currentFTab];
  curr.classList.add("active");
  gsap.set(curr.querySelector(".tab-pane"), { height: curr.dataset.height });

  //
  autoplayFutureTabs();

  // future blurs
  if(!isMobile()) {
    gsap.set(".future-blurs", { xPercent: -65, yPercent: -65 });

    let xTo = gsap.quickTo(".future-blurs", "x", {
        duration: 0.6,
        ease: "power3",
      }),
      yTo = gsap.quickTo(".future-blurs", "y", { duration: 0.6, ease: "power3" });
    // 3D mouse follower
      let futureXTo = gsap.quickTo(".follower3d", "rotationX", {
          duration: 1,
          ease: "power3",
        }),
        futureYTo = gsap.quickTo(".follower3d", "rotationY", {
          duration: 1,
          ease: "power3",
        });
    

    futureBlurMoveHandler = (e) => {
      xTo(e.clientX);
      yTo(e.clientY);
      futureXTo(50 * ((e.clientX - window.innerWidth / 2) / window.innerWidth));
      futureYTo(
        -50 * ((e.clientY - window.innerHeight / 2) / window.innerHeight)
      );
    };
    window.addEventListener("mousemove", futureBlurMoveHandler);
  }

  ScrollTrigger.create({
    trigger: ".FutureGov",
    start: "top bottom",
    end: "bottom center-=15%",
    fastScrollEnd: true,
    onEnter: ({ progress, direction, isActive }) => {
      startFutureBlursAnimation();
      autoplayFTl.play();
    },
    onLeave: ({ progress, direction, isActive }) => {
      stopFutureBlursAnimation();
      autoplayFTl.pause();
    },
    onEnterBack: ({ progress, direction, isActive }) => {
      startFutureBlursAnimation();
      autoplayFTl.play();
    },
    onLeaveBack: ({ progress, direction, isActive }) => {
      stopFutureBlursAnimation();
      autoplayFTl.pause();
    },
    // markers: true,
  });
}
function changeFutureTab(tab) {
  // unset active tab
  const active = document.querySelector(".FutureGov .tab-content.active");
  const activep = active.querySelector(".tab-pane");
  active.classList.remove("active");
  gsap.to(active.querySelector(".progress"), { duration: 0.4, width: "0%" });

  // set clicked tab as active
  const p = tab.querySelector(".tab-pane");
  tab.classList.add("active");

  // gsap
  const tl = gsap.timeline();
  tl.to(activep, {
    duration: tabsSwitchDuration,
    height: 0,
  }).to(
    p,
    {
      duration: tabsSwitchDuration,
      height: tab.dataset.height,
    },
    0
  );
  autoplayFTl.restart();
}

const autoplayFTl = gsap.timeline({ repeat: -1, paused: true });
function autoplayFutureTabs() {
  autoplayFTl.to(
    { time: 0 },
    {
      duration: tabsAutoplayDuration,
      ease: "none",
      onComplete: () => {
        currentFTab = ++currentFTab % futureGovTabs.length;
        changeFutureTab(futureGovTabs[currentFTab]);
      },
      onUpdate: function () {
        const tab = futureGovTabs[currentFTab];
        const currProgress = tab.querySelector(".progress");
        gsap.set(currProgress, { width: this.progress() * 100 + "%" });
      },
    }
  );
}
// swiper
const progressProgress = document.querySelector(".autoplay-progress .progress");
let progressTween;
const swiper = new Swiper(".swiper", {
  modules: [Autoplay, Navigation],
  // spaceBetween: 40,
  // slidesPerView: 3,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  speed: 1500,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    // pauseOnMouseEnter: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
  on: {
    autoplayStart(swiper) {
      startProgress(swiper.params.autoplay.delay);
    },
    autoplay(swiper) {
      resetProgress();
      startProgress(
        swiper.params.autoplay.delay,
        swiper.activeIndex,
        swiper.slides.length
      );
    },
    autoplayPause() {
      if (progressTween) progressTween.pause();
    },
    autoplayResume() {
      if (progressTween) progressTween.resume();
    },
  },
});

function startProgress(delay, index, count) {
  if (progressTween) progressTween.kill();

  progressTween = gsap.fromTo(
    progressProgress,
    { width: "0%" },
    { width: "100%", duration: delay / 1000, ease: "none" }
  );
}
function resetProgress() {
  gsap.set(progressProgress, { width: "0%" });
}

const pinToolCards = function () {
  const cards = document.querySelector(".tools-card");
  const cardHeight = cards.offsetHeight;
  const cardSpacing = 180;

  gsap.set(".tools-card", {
    // y: (index) => 30 * index, // set offset
    transformStyle: "preserve-3d", // For the perspecitve effect
    transformPerspective: 1000, // For the perspecitve effect
    transformOrigin: "center center",
  });
  gsap.set(".tools-cards--wrapper", {
    height: cardHeight,
    maxHeight: cardHeight,
  });
  let pinTl = gsap.timeline({
    defaults: {
      ease: "none",
    },
    scrollTrigger: {
      trigger: ".tools-cards--wrapper",
      start: "top top+=15%",
      end: `${cardHeight * 5} top`,
      scrub: 0.1,
      pin: true,
      fastScrollEnd: true,
      // markers: true,
    },
  });
  document.querySelectorAll(".tools-card").forEach((item, index) => {
    pinTl.from(
      item,
      {
        y: () => (cardHeight + cardSpacing) * index, // Postion cards based on their postion
        duration: () => index * 1, //  Make it so that the total duration is set based on the index of the card
      },
      0
    ); // All tweens start at the same time
  });
  document
    .querySelectorAll(".tools-card:not(:last-child)")
    .forEach((item, index) => {
      pinTl.to(
        item,
        {
          rotationX: 5,
          scale: 0.75,
          duration: 1,
        },
        index
      );
    });
};

const collaborationTexts = function () {
  ScrollTrigger.create({
    trigger: ".Collaboration",
    start: "top center-=" + document.querySelector(".Collaboration .about-text.coll-1").clientHeight * 2,
    toggleClass: {
      targets: [".h1 span", ".about-text"],
      className: "alt",
    },
    fastScrollEnd: true,
    // markers: true
  });
};

// Key Areas
const kaTitle = SplitText.create(".KeyAreas .title", { type: "chars", reduceWhiteSpace: false });
const kaTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".KeyAreas .h1",
    start: "top center",
    // end: "top center-=15%",
    // scrub: true,
    toggleActions: "play none resume reverse",
    fastScrollEnd: true,
    // markers: true,
  },
});
kaTl.from(kaTitle.chars, {
  duration: 0.8,
  top: "-=100",
  autoAlpha: 0,
  stagger: 0.05,
  ease: "circ.out",
  // scrollTrigger: {
  //   trigger: ".KeyAreas .h1",
  //   start: "bottom center",
  //   // end: 100,
  //   // scrub: true,
  //   toggleActions: "play pause none none",
  //   markers: true,
  // }
});

function initAccordionClicks() {
  const accordions = document.querySelectorAll(".accordion-button");
  accordions.forEach((acc) => {
    acc.addEventListener("click", (e) => {
      ScrollTrigger.refresh();
    });
  });
}